/* eslint-disable */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import ELEMENT from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/main.css' // 自定义main 样式表
import '@/assets/css/mobile.css' // 自定义main 样式表
import animated from 'animate.css'
import qqConsult from '@/utils/qqConsult'
// 引入重置message，防止重复点击重复弹出message弹框
import {
  message
} from '@/utils/message.js'

import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'




Vue.config.productionTip = false

Vue.use(ELEMENT)
Vue.use(animated)
Vue.use(qqConsult)
Vue.prototype.$message = message

Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>',
  // ,
  // render: h => h(App),
  // // eslint-disable-next-line
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js